// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import { C, radius, shadow } from '../styles';

// const API = 'https://reportautomation.finkraftai.com/api';
// const OTP_LENGTH = 6;

// export default function LoginPage() {
//   const { login } = useAuth();
//   const [step,     setStep]     = useState('email'); // 'email' | 'otp'
//   const [email,    setEmail]    = useState('');
//   const [otp,      setOtp]      = useState('');
//   const [error,    setError]    = useState('');
//   const [info,     setInfo]     = useState('');
//   const [loading,  setLoading]  = useState(false);
//   const [cooldown, setCooldown] = useState(0); // seconds until resend allowed

//   const otpInputRef = useRef(null);

//   // Countdown timer for resend
//   useEffect(() => {
//     if (cooldown <= 0) return;
//     const t = setTimeout(() => setCooldown(c => c - 1), 1000);
//     return () => clearTimeout(t);
//   }, [cooldown]);

//   // Auto-focus the OTP input when it appears
//   useEffect(() => {
//     if (step === 'otp' && otpInputRef.current) {
//       otpInputRef.current.focus();
//     }
//   }, [step]);

//   const requestOtp = async () => {
//     setError(''); setInfo(''); setLoading(true);
//     try {
//       const { data } = await axios.post(`${API}/otp/request`, { email });
//       if (data.ok) {
//         setStep('otp');
//         setCooldown(60);
//         // Dev-mode convenience: if SMTP isn't configured, backend echoes
//         // the OTP back so you can test locally. In prod this field is absent.
//         if (data.dev_otp) {
//           setInfo(`Dev mode: OTP is ${data.dev_otp} (SMTP not configured — check server console)`);
//         } else {
//           setInfo(data.message || 'A sign-in code has been sent to your email.');
//         }
//       } else {
//         setError(data.error || 'Could not send code.');
//       }
//     } catch (e) {
//       setError('Cannot reach server — make sure the backend is running on port 5050');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const verifyOtp = async () => {
//     setError(''); setInfo(''); setLoading(true);
//     try {
//       const { data } = await axios.post(`${API}/otp/verify`, { email, code: otp });
//       if (data.ok) {
//         login(data);
//       } else {
//         setError(data.error || 'Invalid code.');
//       }
//     } catch (e) {
//       const msg = e?.response?.data?.error;
//       setError(msg || 'Could not verify code. Try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (loading) return;
//     if (step === 'email') requestOtp();
//     else verifyOtp();
//   };

//   const changeEmail = () => {
//     setStep('email');
//     setOtp('');
//     setError('');
//     setInfo('');
//   };

//   const resend = async () => {
//     if (cooldown > 0 || loading) return;
//     await requestOtp();
//   };

//   const inputStyle = {
//     width: '100%',
//     background: C.surface2,
//     border: `1px solid ${C.border2}`,
//     borderRadius: radius.md,
//     padding: '11px 14px',
//     color: C.text,
//     fontFamily: 'Inter,sans-serif',
//     fontSize: 14,
//     marginBottom: 14,
//     outline: 'none',
//     transition: 'all .15s',
//   };

//   const otpInputStyle = {
//     ...inputStyle,
//     fontSize: 22,
//     letterSpacing: '0.5em',
//     textAlign: 'center',
//     fontFamily: 'JetBrains Mono, ui-monospace, monospace',
//     fontWeight: 600,
//   };

//   const canSubmit = step === 'email'
//     ? email.includes('@') && !loading
//     : otp.length === OTP_LENGTH && !loading;

//   return (
//     <div style={{
//       minHeight: '100vh',
//       display: 'flex', alignItems: 'center', justifyContent: 'center',
//       padding: '24px',
//       position: 'relative',
//       overflow: 'hidden',
//     }}>
//       {/* decorative blurred shapes for depth */}
//       <div aria-hidden style={{
//         position:'absolute', top:-140, right:-140, width:420, height:420,
//         borderRadius:'50%', background:'radial-gradient(circle, rgba(8,145,178,0.22), transparent 70%)',
//         filter:'blur(30px)', pointerEvents:'none',
//       }}/>
//       <div aria-hidden style={{
//         position:'absolute', bottom:-160, left:-160, width:460, height:460,
//         borderRadius:'50%', background:'radial-gradient(circle, rgba(20,184,166,0.18), transparent 70%)',
//         filter:'blur(30px)', pointerEvents:'none',
//       }}/>

//       <div style={{
//         position:'relative',
//         background: C.surface,
//         border: `1px solid ${C.border2}`,
//         borderRadius: radius.xl,
//         padding: '44px 40px',
//         width: 420,
//         boxShadow: shadow.lg,
//         animation: 'slideUp .3s ease',
//       }}>
//         {/* Logo */}
//         <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
//                       marginBottom:26 }}>
//           <img src="/finkraft-logo-light.png" alt="Finkraft.ai"
//                style={{ height:32, width:'auto' }}/>
//         </div>

//         <div style={{ textAlign:'center', marginBottom:28 }}>
//           <h2 style={{ fontFamily:'Syne,sans-serif', fontSize:24, fontWeight:600,
//                        color: C.text, marginBottom:6 }}>
//             GST Reconciliation
//           </h2>
//           <p style={{ color: C.muted, fontSize:13 }}>
//             {step === 'email'
//               ? 'Sign in with your work email'
//               : `Enter the ${OTP_LENGTH}-digit code we sent to`}
//           </p>
//           {step === 'otp' && (
//             <p style={{ color: C.text, fontSize:13, fontWeight:600, marginTop:2 }}>
//               {email}{' '}
//               <button type="button" onClick={changeEmail}
//                 style={{ background:'none', border:'none', color: C.accent,
//                          cursor:'pointer', fontSize:12, fontWeight:500,
//                          textDecoration:'underline', padding:0, marginLeft:4 }}>
//                 change
//               </button>
//             </p>
//           )}
//         </div>

//         <form onSubmit={handleSubmit}>
//           {step === 'email' && (
//             <>
//               <label style={{ display:'block', fontSize:11, color: C.muted,
//                               marginBottom:6, textTransform:'uppercase',
//                               letterSpacing:'.06em', fontWeight:600 }}>Email</label>
//               <input
//                 style={inputStyle}
//                 type="email"
//                 placeholder="you@company.com"
//                 value={email}
//                 onChange={e => setEmail(e.target.value)}
//                 onFocus={e => { e.target.style.borderColor = C.accent; e.target.style.boxShadow = shadow.glow; e.target.style.background = C.surface; }}
//                 onBlur={e  => { e.target.style.borderColor = C.border2; e.target.style.boxShadow = 'none'; e.target.style.background = C.surface2; }}
//                 autoComplete="email"
//                 autoFocus
//                 required
//               />
//             </>
//           )}

//           {step === 'otp' && (
//             <>
//               <label style={{ display:'block', fontSize:11, color: C.muted,
//                               marginBottom:6, textTransform:'uppercase',
//                               letterSpacing:'.06em', fontWeight:600 }}>
//                 Sign-in code
//               </label>
//               <input
//                 ref={otpInputRef}
//                 style={otpInputStyle}
//                 type="text"
//                 inputMode="numeric"
//                 pattern="[0-9]*"
//                 maxLength={OTP_LENGTH}
//                 placeholder="••••••"
//                 value={otp}
//                 onChange={e => setOtp(e.target.value.replace(/\D/g, '').slice(0, OTP_LENGTH))}
//                 onFocus={e => { e.target.style.borderColor = C.accent; e.target.style.boxShadow = shadow.glow; e.target.style.background = C.surface; }}
//                 onBlur={e  => { e.target.style.borderColor = C.border2; e.target.style.boxShadow = 'none'; e.target.style.background = C.surface2; }}
//                 autoComplete="one-time-code"
//               />
//               <div style={{ fontSize:12, color: C.muted, marginBottom:14,
//                             display:'flex', justifyContent:'space-between',
//                             alignItems:'center' }}>
//                 <span>Didn't receive it?</span>
//                 <button type="button"
//                   onClick={resend}
//                   disabled={cooldown > 0 || loading}
//                   style={{ background:'none', border:'none',
//                            color: cooldown > 0 ? C.muted : C.accent,
//                            cursor: cooldown > 0 ? 'default' : 'pointer',
//                            fontSize:12, fontWeight:600, padding:0 }}>
//                   {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend code'}
//                 </button>
//               </div>
//             </>
//           )}

//           {info && (
//             <div style={{ color: C.accent, fontSize:12, marginBottom:12,
//                           background: 'rgba(8,145,178,0.08)',
//                           border:`1px solid ${C.accent}33`,
//                           borderRadius: radius.sm,
//                           padding:'9px 12px', lineHeight:1.5 }}>{info}</div>
//           )}

//           {error && (
//             <div style={{ color: C.danger, fontSize:12, marginBottom:12,
//                           background: C.dangerBg,
//                           border:`1px solid ${C.danger}33`,
//                           borderRadius: radius.sm,
//                           padding:'9px 12px' }}>{error}</div>
//           )}

//           <button type="submit" disabled={!canSubmit} style={{
//             width:'100%',
//             background: !canSubmit
//               ? C.surface3
//               : `linear-gradient(135deg, ${C.accent} 0%, ${C.teal} 100%)`,
//             border:'none', borderRadius: radius.md, padding:'12px',
//             color: !canSubmit ? C.muted : 'white',
//             fontFamily:'Inter,sans-serif', fontSize:14, fontWeight:600,
//             letterSpacing:'.02em',
//             cursor: !canSubmit ? 'not-allowed' : 'pointer',
//             transition:'all .2s',
//             boxShadow: !canSubmit ? 'none' : '0 4px 12px rgba(8,145,178,0.25)',
//           }}
//           onMouseEnter={e => { if (canSubmit) e.currentTarget.style.transform = 'translateY(-1px)'; }}
//           onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
//           >
//             {loading
//               ? (step === 'email' ? 'Sending code…' : 'Verifying…')
//               : (step === 'email' ? 'Send code →'   : 'Verify & sign in →')}
//           </button>
//         </form>

//         <div style={{ marginTop:22, background: C.surface2,
//                       border: `1px dashed ${C.border2}`,
//                       borderRadius: radius.md,
//                       padding:'12px 14px', fontSize:11.5, color: C.muted,
//                       lineHeight:1.6, textAlign:'center' }}>
//           Use the email address registered by your administrator.
//           <br/>
//           You'll receive a one-time code to sign in.
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { C, radius, shadow } from '../styles';

const API = 'https://reportautomation.finkraftai.com/api';
const OTP_LENGTH = 6;

export default function LoginPage() {
  const { login } = useAuth();
  const [step,     setStep]     = useState('email');
  const [email,    setEmail]    = useState('');
  const [otp,      setOtp]      = useState('');
  const [error,    setError]    = useState('');
  const [info,     setInfo]     = useState('');
  const [loading,  setLoading]  = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const otpInputRef = useRef(null);

  // Simple responsive breakpoint watcher (no extra dependency).
  const [isNarrow, setIsNarrow] = useState(
    typeof window !== 'undefined' && window.innerWidth < 900
  );
  useEffect(() => {
    const onResize = () => setIsNarrow(window.innerWidth < 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  useEffect(() => {
    if (step === 'otp' && otpInputRef.current) otpInputRef.current.focus();
  }, [step]);

  const requestOtp = async () => {
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/otp/request`, { email });
      if (data.ok) {
        setStep('otp');
        setCooldown(60);
        // Generic message only — never leak dev_otp to UI.
        setInfo(data.message || 'A sign-in code has been sent to your email.');
      } else {
        setError(data.error || 'Could not send code.');
      }
    } catch (e) {
      setError('Cannot reach server — make sure the backend is running on port 5050');
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/otp/verify`, { email, code: otp });
      if (data.ok) login(data);
      else setError(data.error || 'Invalid code.');
    } catch (e) {
      setError(e?.response?.data?.error || 'Could not verify code. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    if (step === 'email') requestOtp(); else verifyOtp();
  };
  const changeEmail = () => { setStep('email'); setOtp(''); setError(''); setInfo(''); };
  const resend = async () => { if (cooldown === 0 && !loading) await requestOtp(); };

  const canSubmit = step === 'email'
    ? email.includes('@') && email.includes('.') && !loading
    : otp.length === OTP_LENGTH && !loading;

  // ── Styles ────────────────────────────────────────────────────────────────
  const inputStyle = {
    width: '100%',
    background: '#FFFFFF',
    border: `1.5px solid ${C.border2}`,
    borderRadius: radius.md,
    padding: '12px 14px',
    color: C.text,
    fontFamily: 'Inter,sans-serif',
    fontSize: 14,
    outline: 'none',
    transition: 'border-color .15s, box-shadow .15s',
    boxSizing: 'border-box',
  };
  const otpInputStyle = {
    ...inputStyle,
    fontSize: 22,
    letterSpacing: '0.4em',
    textAlign: 'center',
    fontFamily: 'JetBrains Mono, ui-monospace, monospace',
    fontWeight: 600,
    padding: '13px',
  };
  const onFocus = e => {
    e.target.style.borderColor = C.accent;
    e.target.style.boxShadow = shadow.glow;
  };
  const onBlur  = e => {
    e.target.style.borderColor = C.border2;
    e.target.style.boxShadow = 'none';
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: isNarrow ? 'column' : 'row',
      background: C.surface,
    }}>
      {/* ── LEFT: Clean brand panel ───────────────────────────────────── */}
      <BrandPanel isNarrow={isNarrow} />

      {/* ── RIGHT: Form ───────────────────────────────────────────────── */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isNarrow ? '32px 20px 48px' : '40px',
        background: C.surface,
      }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          {/* Heading */}
          <div style={{ marginBottom: 28 }}>
            <h1 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 26,
              fontWeight: 700,
              color: C.text,
              letterSpacing: '-0.01em',
              lineHeight: 1.2,
              marginBottom: 8,
            }}>
              {step === 'email' ? 'Sign in' : 'Check your email'}
            </h1>
            <p style={{
              fontSize: 14,
              color: C.muted,
              lineHeight: 1.5,
            }}>
              {step === 'email'
                ? 'Enter your work email and we\u2019ll send you a one-time code.'
                : <>We sent a {OTP_LENGTH}-digit code to{' '}
                    <span style={{ color: C.text, fontWeight: 600 }}>{email}</span>.
                  </>}
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {step === 'email' ? (
              <div style={{ marginBottom: 16 }}>
                <label htmlFor="email" style={labelStyle}>Email address</label>
                <input
                  id="email"
                  style={inputStyle}
                  type="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  autoComplete="email"
                  autoFocus
                  required
                />
              </div>
            ) : (
              <>
                <div style={{ marginBottom: 8 }}>
                  <label htmlFor="otp" style={labelStyle}>Sign-in code</label>
                  <input
                    id="otp"
                    ref={otpInputRef}
                    style={otpInputStyle}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={OTP_LENGTH}
                    placeholder="••••••"
                    value={otp}
                    onChange={e => setOtp(e.target.value.replace(/\D/g,'').slice(0, OTP_LENGTH))}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    autoComplete="one-time-code"
                  />
                </div>
                <div style={{
                  display:'flex', justifyContent:'space-between', alignItems:'center',
                  fontSize: 13, marginBottom: 16,
                }}>
                  <button type="button" onClick={changeEmail} style={linkBtnStyle}>
                    ← Use different email
                  </button>
                  <button type="button" onClick={resend}
                    disabled={cooldown > 0 || loading}
                    style={{ ...linkBtnStyle,
                             color: cooldown > 0 ? C.mutedSoft : C.accent,
                             cursor: cooldown > 0 ? 'default' : 'pointer' }}>
                    {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend code'}
                  </button>
                </div>
              </>
            )}

            {info && <AlertBox kind="info"  text={info} />}
            {error && <AlertBox kind="error" text={error} />}

            <button type="submit" disabled={!canSubmit}
              style={submitStyle(canSubmit)}
              onMouseEnter={e => { if (canSubmit) {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(8,145,178,0.28)';
              }}}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = canSubmit
                  ? '0 4px 12px rgba(8,145,178,0.20)' : 'none';
              }}>
              {loading
                ? (step === 'email' ? 'Sending code…' : 'Verifying…')
                : (step === 'email' ? 'Continue'      : 'Sign in')}
            </button>
          </form>

          <div style={{
            marginTop: 24, paddingTop: 18,
            borderTop: `1px solid ${C.border}`,
            display:'flex', alignItems:'center', gap: 9,
            fontSize: 12, color: C.muted,
          }}>
            <LockIcon/>
            <span>Secured with one-time codes. No passwords.</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Left brand panel — clean, calm, focused ─────────────────────────────────
function BrandPanel({ isNarrow }) {
  if (isNarrow) {
    // Collapse to a slim header on narrow screens with logo + accent line.
    return (
      <div style={{
        background: '#FFFFFF',
        borderBottom: `1px solid ${C.border2}`,
        padding: '20px 24px',
        display:'flex', alignItems:'center', justifyContent:'center',
        position:'relative',
      }}>
        <img src="/finkraft-logo-light.png" alt="Finkraft.ai"
             style={{ height: 28 }}/>
        {/* Thin gradient accent line at the bottom */}
        <div style={{
          position:'absolute', left:0, right:0, bottom:0, height: 3,
          background: `linear-gradient(90deg, ${C.accent2}, ${C.accent}, ${C.teal})`,
        }}/>
      </div>
    );
  }

  return (
    <div style={{
      flex: 1,
      position: 'relative',
      overflow: 'hidden',
      background: `linear-gradient(145deg, #0B3B4E 0%, #0E7490 55%, #0891B2 100%)`,
      color: '#fff',
      padding: '56px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}>
      {/* Soft radial glows for depth — very subtle */}
      <div aria-hidden style={{
        position:'absolute', inset: 0,
        backgroundImage:
          `radial-gradient(circle at 85% 15%, rgba(94,234,212,0.22), transparent 45%),
           radial-gradient(circle at 15% 85%, rgba(6,182,212,0.18), transparent 50%)`,
        pointerEvents: 'none',
      }}/>

      {/* ── Top: Logo on a solid, bright background card ─────────────── */}
      <div style={{ position:'relative', zIndex:1 }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center',
          padding: '12px 18px',
          background: '#FFFFFF',
          borderRadius: radius.md,
          boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)',
        }}>
          <img src="/finkraft-logo-light.png" alt="Finkraft.ai"
               style={{ height: 28, display:'block' }}/>
        </div>
      </div>

      {/* ── Middle: Simple welcome message ───────────────────────────── */}
      <div style={{ position:'relative', zIndex:1, maxWidth: 480 }}>
        <p style={{
          fontSize: 13,
          fontWeight: 600,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: 'rgba(255,255,255,0.65)',
          marginBottom: 18,
        }}>
          Welcome to
        </p>
        <h2 style={{
          fontFamily: 'Syne, sans-serif',
          fontSize: 'clamp(32px, 4vw, 52px)',
          fontWeight: 700,
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          marginBottom: 20,
          color: '#FFFFFF',
        }}>
          GST Reconciliation
        </h2>
        <p style={{
          fontSize: 16,
          lineHeight: 1.6,
          color: 'rgba(255,255,255,0.82)',
          maxWidth: 420,
        }}>
          Sign in to match invoices, review flags, and download
          audit-ready reports.
        </p>
      </div>

      {/* ── Bottom: Footer row ───────────────────────────────────────── */}
      <div style={{
        position:'relative', zIndex:1,
        fontSize: 12,
        color: 'rgba(255,255,255,0.55)',
        display:'flex', justifyContent:'space-between', alignItems:'center',
      }}>
        <span>© {new Date().getFullYear()} Finkraft.ai</span>
        <span style={{ display:'inline-flex', alignItems:'center', gap:7 }}>
          <span style={{
            width:6, height:6, borderRadius:'50%',
            background:'#5EEAD4',
            boxShadow:'0 0 8px rgba(94,234,212,0.9)',
          }}/>
          All systems operational
        </span>
      </div>
    </div>
  );
}

// ── Small helpers ───────────────────────────────────────────────────────────
const labelStyle = {
  display:'block',
  fontSize: 12,
  color: C.textSoft,
  marginBottom: 7,
  fontWeight: 600,
  letterSpacing: '0.01em',
};

const linkBtnStyle = {
  background:'none', border:'none', padding:0,
  fontSize: 13, fontWeight: 500, color: C.accent, cursor:'pointer',
  fontFamily: 'Inter,sans-serif',
};

const submitStyle = (enabled) => ({
  width:'100%',
  border:'none',
  borderRadius: radius.md,
  padding: '13px',
  fontFamily: 'Inter,sans-serif',
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: '0.01em',
  color: enabled ? '#fff' : C.mutedSoft,
  background: enabled
    ? `linear-gradient(135deg, ${C.accent2} 0%, ${C.accent} 60%, ${C.teal} 100%)`
    : C.surface3,
  cursor: enabled ? 'pointer' : 'not-allowed',
  boxShadow: enabled ? '0 4px 12px rgba(8,145,178,0.20)' : 'none',
  transition: 'all .2s ease',
});

function AlertBox({ kind, text }) {
  const palette = kind === 'error'
    ? { bg: C.dangerBg, border: `${C.danger}33`, color: C.danger, icon: '!' }
    : { bg: C.accentBg, border: `${C.accent}33`, color: C.accent2, icon: 'i' };
  return (
    <div style={{
      display:'flex', gap: 10, alignItems:'flex-start',
      background: palette.bg,
      border: `1px solid ${palette.border}`,
      borderRadius: radius.sm,
      padding: '10px 12px',
      marginBottom: 14,
      fontSize: 13,
      color: palette.color,
      lineHeight: 1.5,
    }}>
      <span style={{
        flexShrink: 0,
        display:'grid', placeItems:'center',
        width: 18, height: 18, borderRadius: '50%',
        background: palette.color,
        color: '#fff', fontSize: 11, fontWeight: 700,
        marginTop: 1,
      }}>{palette.icon}</span>
      <span>{text}</span>
    </div>
  );
}

function LockIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth="2" strokeLinecap="round"
         strokeLinejoin="round" style={{ flexShrink: 0 }}>
      <rect x="3" y="11" width="18" height="11" rx="2"/>
      <path d="M7 11V7a5 5 0 0110 0v4"/>
    </svg>
  );
}